import { parseQuery } from 'ufo';

onReady(() => {
  const query = parseQuery(window.location.search);
  const idField = document.querySelector<HTMLInputElement>('input[name="login"]');
  const passwordField = document.querySelector<HTMLInputElement>('input[name="password"]');
  if (idField && query.id) {
    idField.value = Array.isArray(query.id) ? query.id[0] : query.id;
  }
  if (passwordField && query.password) {
    passwordField.value = Array.isArray(query.password) ? query.password[0] : query.password;
  }
});
